// src/hooks/useCatalogs.js
import { useEffect, useState } from 'react';
import { fetchCatalog } from '../api/catalogClient';

export function useCatalogs(enabled = true) {
  const [state, setState] = useState({ loading: true, error: null, catalogs: {} });

  useEffect(() => {
    if (!enabled) {
      setState({ loading: false, error: null, catalogs: {} });
      return;
    }
    let live = true;
    (async () => {
      try {
        const [liquor, liqueur, beer, wine, champagne, syrups, soda, crown] = await Promise.all([
          fetchCatalog('liquor'),
          fetchCatalog('liqueur'),
          fetchCatalog('beer'),
          fetchCatalog('wine'),
          fetchCatalog('champagne'),
          fetchCatalog('syrups'),
          fetchCatalog('soda'),
          fetchCatalog('crown'),
        ]);
        if (live) setState({ loading: false, error: null, catalogs: { liquor, liqueur, beer, wine, champagne, syrups, soda, crown } });
      } catch (e) {
        if (live) setState({ loading: false, error: e, catalogs: {} });
      }
    })();
    return () => { live = false; };
  }, [enabled]);

  return state;
}
